import { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Box, Flex, Text } from 'rebass'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { FiX } from 'react-icons/fi'
import { DataContext } from '../../contexts/dataContext'
import { Theme } from '../../styles/settings/theme'
import { BASE_URL } from '../../utils/constants'
import Arrows from '../atoms/Arrows'
import Filter from '../molecules/Filter'
import YearSelector from '../atoms/YearSelector'
import { lang } from '../../utils/lang'

const Drawer = styled(Box)`
  width: 100%;
  height: 100vh;
  position: ${(props) => (props.isOpen ? 'relative' : 'fixed')};
  bottom: 0;
  z-index: 9;
  overflow-y: ${(props) => (props.isOpen ? 'scroll' : 'none')};
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  &.scrollbar::-webkit-scrollbar {
    /* WebKit */
    width: 0;
  }
  background-color: ${(props) => props.theme.colors.steelBlue};
  font-family: ${(props) => props.theme.fonts.condensed};
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.71);
  padding: 3rem 2rem 2rem 2rem;
  display: ${(props) => (props.intro === 'closed' ? 'block' : 'none')};
  transform: ${(props) =>
    props.isOpen ? 'translateY(4.5rem)' : 'translateY(calc(100% - 2.6rem))'};
  transition: all 0.5s ease;
  ${Mq.xs} {
    width: 16rem;
    position: fixed;
    overflow-y: scroll;
    transform: translateX(${(props) => (props.isOpen ? 0 : '-14rem')});
    top: 4.5rem;
    padding: 2.5rem 2.5rem 2rem 1rem;
    clip-path: inset(
      0px -40px 0px 0px
    ); // to get rid of shadow on top in navbar
  }
  ${Mq.sm} {
    top: 3rem;
  }
`

const DrawerControl = styled(Flex)`
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  top: ${(props) => (props.hasNoFilters ? '-1.4rem' : '-2rem')};
  left: calc(50% - 6.5rem);
  height: 6rem;
  width: 13.5rem;
  font-family: ${(props) =>
    props.ui === 'en' ? props.theme.fonts.condensed : 'Arial, sans-serif'};
  z-index: 10;
  transition: all 0.5s ease;
  ${Mq.xs} {
    //width: 6rem;
    display: ${(props) => (props.intro === 'closed' ? 'flex' : 'none')};
    top: calc(50% - 2.8rem);
    //right: -4rem;
    left: 9rem;
    transform: translateX(${(props) => (props.isOpen ? 0 : '-14rem')})
      rotate(-90deg);
  }
`
const DrawerClickArea = styled(Box)`
  display: none;
  ${Mq.xs} {
    display: block;
    width: 2rem;
    height: 100%;
    position: absolute;
    background-color: transparent;
    top: 0;
    right: 0;
    cursor: pointer;
  }
`
const DrawerLabel = styled(Flex)`
  width: 100%;
  justify-content: ${(props) =>
    props.hasNoFilters || props.isOpen ? 'center' : 'space-between'};
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: ${(props) => (props.ui === 'en' ? '1.8px' : 0)};
  z-index: 2;
  //background-color: ${(props) => props.theme.colors.steelBlue};
  margin-top: ${(props) => (props.hasNoFilters ? '-2rem' : '-1rem')};
  padding: 0.5rem;
  cursor: pointer;
  ${Mq.xs} {
    width: auto;
    height: 1.5rem;
    margin-top: 0;
    padding: 0;
  }
`
const DrawerKnob = styled(Flex)`
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.steelBlue};
  //box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.71);
  border-radius: 50%;
  width: 2.25rem;
  height: 2.25rem;
  transform: rotate(-90deg);
  margin-top: -3.5rem;
  padding-left: 0.7rem;
  cursor: pointer;
  ${Mq.xs} {
    margin-top: -1rem;
    padding-left: 0.75rem;
    transform: rotate(90deg);
  }
`
const SectionHead = styled(Text)`
  font-size: 1rem;
  text-transform: uppercase;
  padding-bottom: 0.25rem;
`
const Border = styled(Box)`
  border-top: 1px solid ${(props) => props.theme.colors.white};
  width: 100%;
`
const PillBox = styled(Box)`
  position: relative;
  transition: all 1s ease;
  font-family: Arial; // should be Arial anyway but need to clarify for mobile so that it doesn't inherit from filter drawer
  ${Mq.xs} {
    transform: translateX(${(props) => (props.isOpen ? '20rem' : '6rem')});
    position: absolute;
    top: 8.5rem;
    z-index: 1;
  }
  ${Mq.sm} {
    top: 7rem;
  }
`

const Pill = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.aqua};
  color: ${(props) => props.theme.colors.black};
  border-radius: 500px;
  font-weight: 400;
  margin-bottom: 0;
  width: 100%;
  height: 1.55rem;
  padding: 0 0.75rem;
  font-size: ${(props) => (props.ui === 'en' ? '0.8rem' : '1rem')};
  margin-bottom: 0.5rem;
  cursor: pointer;
  ${Mq.xs} {
    width: unset;
  }
`

const MobileApplyButton = styled(Flex)`
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.aqua};
  color: ${(props) => props.theme.colors.black};
  text-transform: uppercase;
  border-radius: 500px;
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 0.9rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  margin-bottom: 0;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.44);
`
const MobileFilterIndicator = styled(Flex)`
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.aqua};
  color: ${(props) => props.theme.colors.steelBlue};
  text-transform: uppercase;
  border-radius: 500px;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 0;
`
const MobileFilterIndicatorBox = styled(Box)`
  margin-top: 0.2rem;
  display: ${(props) =>
    props.hasNoFilters || props.isOpen ? 'none' : 'block'};

  ${Mq.xs} {
    display: none;
  }
`
const CloseX = styled(Box)`
  padding: ${(props) =>
    props.ui === 'en' ? '0.25rem 0 0 0.5rem' : '0.35rem .5rem 0 0'};
`

const MobileApply = styled(Flex)`
  position: absolute;
  top: 0.45rem;
  right: 1rem;
  z-index: 10;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  ${Mq.xs} {
    display: none;
  }
`
const MobileBox = styled(Box)`
  ${Mq.xs} {
    display: none;
  }
`
const NonMobileBox = styled(Box)`
  display: none;
  ${Mq.xs} {
    display: block;
  }
`
const StyledP = styled.p`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 0.75rem;
`
// const Line = styled(Box)`
//   margin: 1rem 0;
//   border-top: 1px solid ${(props) => props.theme.colors.white};
// `
const FilterDrawer = ({
  handleDrawer,
  isOpen,
  selectedYear,
  setSelectedYear,
  //vocabData
  reliVocab,
  reliVocabFa,
  genderVocab,
  genderVocabFa,
  occuVocab,
  occuVocabFa,
  eduVocab,
  eduVocabFa,
  threatVocab,
  threatVocabFa,
  killingVocab,
  killingVocabFa
}) => {
  const {
    ui,
    setQuery,
    setNonFatalQuery,
    intro,
    selections,
    setSelections,
    setFormattedData,
    setFormattedNonFatalData
  } = useContext(DataContext)

  const [hasNoFilters, setHasNoFilters] = useState(true)
  // const [selections, setSelections] = useState({
  //   Religion: 'ALL',
  //   Occupation: 'ALL',
  //   // Affiliation: 'ALL',
  //   Education: 'ALL',
  //   Gender: 'ALL',
  //   'Threats or failed attempts': 'ALL',
  //   'Modes of killing': 'ALL',
  //   Arrests: 'ALL',
  //   Prosecution: 'ALL'
  // })

  //these selects don't have vocab from the api; they are fields on each person that are 0 or 1
  const arrestVocab = {
    0: { title: 'Arrests not made' },
    1: { title: 'Arrests made' }
  }
  const arrestVocabFa = {
    0: { title: lang['fa']['Not Arrested'] },
    1: { title: lang['fa']['Arrested'] }
  }

  const prosecutionVocab = {
    0: { title: 'Prosecutions not attempted' },
    1: { title: 'Prosecutions attempted' }
  }
  const prosecutionVocabFa = {
    0: { title: lang['fa']['Not Prosecuted'] },
    1: { title: lang['fa']['Prosecuted'] }
  }

  const none = {
    X: { title: 'None' }
  }
  const noneFa = {
    X: { title: lang['fa']['None'] }
  }

  const vocabLookup = {
    Religion: { en: reliVocab, fa: reliVocabFa },
    Gender: { en: genderVocab, fa: genderVocabFa },
    Occupation: { en: occuVocab, fa: occuVocabFa },
    Education: { en: eduVocab, fa: eduVocabFa },
    'Threats or failed attempts': {
      en: { ...none, ...threatVocab },
      fa: { ...noneFa, ...threatVocabFa }
    },
    'Modes of killing': {
      en: { ...none, ...killingVocab },
      fa: { ...noneFa, ...killingVocabFa }
    },
    Arrests: { en: arrestVocab, fa: arrestVocabFa },
    Prosecution: { en: prosecutionVocab, fa: prosecutionVocabFa }
  }

  const fields = ['Religion', 'Occupation', 'Education', 'Gender']

  const incidentFields = ['Threats or failed attempts', 'Modes of killing']

  const legalFields = ['Arrests', 'Prosecution']

  const allFields = fields.concat(incidentFields).concat(legalFields)

  const handleChange = (e) => {
    //console.log('changing selections')
    setSelections({
      ...selections,
      [e.target.name]: e.target.value
    })
  }

  const getId = (category, selected) => {
    const obj = vocabLookup[category]['en']
    if (obj) {
      for (const [key, value] of Object.entries(obj)) {
        if (value.title === selected) {
          return key
        }
      }
    }
  }

  function buildQuery(selections) {
    const lang = ui === 'fa' ? 'fa/' : ''
    var killing_id = 21
    var threat_id = 1
    if (selections['Religion'] !== 'ALL') {
      var reli_id = getId('Religion', selections['Religion'])
    }
    if (selections['Occupation'] !== 'ALL') {
      var occu_id = getId('Occupation', selections['Occupation'])
    }
    if (selections['Education'] !== 'ALL') {
      var educ_id = getId('Education', selections['Education'])
    }
    if (selections['Gender'] !== 'ALL') {
      var gend_id = getId('Gender', selections['Gender'])
    }
    if (selections['Modes of killing'] !== 'ALL') {
      killing_id = getId('Modes of killing', selections['Modes of killing'])
    }
    if (selections['Threats or failed attempts'] !== 'ALL') {
      threat_id = getId(
        'Threats or failed attempts',
        selections['Threats or failed attempts']
      )
    }
    const base = `${BASE_URL}/${lang}omiddata/getperson?viol_id=${killing_id}`
    const nonFatalBase = `${BASE_URL}/${lang}omiddata/getperson?nonfatal=${threat_id}`
    const fields =
      '&fields=fnames,sname,age,viol_startdate,viol_full_placename,viol_coordinates,photo_id,was_arrest,was_prosecution'
    const nonFatalFields =
      '&fields=fnames,sname,age,viol_startdate,viol_full_placename,viol_coordinates,photo_id,was_arrest,was_prosecution,non_fatal'
    const q1 =
      killing_id === 'X'
        ? null
        : base +
          (reli_id ? `&reli_id=${reli_id}` : '') +
          (occu_id ? `&occu_id=${occu_id}` : '') +
          (educ_id ? `&educ_id=${educ_id}` : '') +
          (gend_id ? `&gend_id=${gend_id}` : '') +
          fields

    const q2 =
      threat_id === 'X'
        ? null
        : nonFatalBase +
          (reli_id ? `&reli_id=${reli_id}` : '') +
          (occu_id ? `&occu_id=${occu_id}` : '') +
          (educ_id ? `&educ_id=${educ_id}` : '') +
          (gend_id ? `&gend_id=${gend_id}` : '') +
          nonFatalFields
    //console.log('building query')
    return { q1, q2 }
  }

  const getQueryStrings = () => {
    const { q1, q2 } = buildQuery(selections)
    setQuery(q1)
    setNonFatalQuery(q2)
    //console.log('q1', q1)
    //console.log('q2', q2)
    if (!q1) setFormattedData([])
    if (!q2) setFormattedNonFatalData([])
  }

  //hook so that useEffect doesn't run on mount, but only afterwards if selections in filters have changed
  // function useDidUpdateEffect(fn, inputs) {
  //   const didMountRef = useRef(false)
  //   console.log('updating')
  //   useEffect(() => {
  //     if (didMountRef.current) fn()
  //     else didMountRef.current = true
  //   }, [inputs, fn])
  // }

  //useDidUpdateEffect(() => getQueryStrings(selections), selections)
  // useEffect(() => {

  // }, [selections])

  useEffect(() => {
    getQueryStrings()
    const filterIsNotSelected = allFields.every(
      (field) => selections[field] === 'ALL'
    )
    setHasNoFilters(filterIsNotSelected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selections])

  //get farsi option value to display in pill box
  const getFaValue = (field) => {
    const valueINeedToFind = selections[field]
    //iterate through en vocab to get id
    const id = getId(field, valueINeedToFind)
    //iterate through fa vocab using id to get val
    const obj = vocabLookup[field]['fa']
    if (obj) {
      for (const [key, value] of Object.entries(obj)) {
        if (key === id) {
          return value.title
        }
      }
    }
  }

  const closePill = (field) => {
    setSelections({
      ...selections,
      [field]: 'ALL'
    })
  }

  const dir = ui === 'en' ? 'ltr' : 'rtl'
  return (
    <>
      {/* On desktop, Drawer Control has to be outside of Drawer in order for the knob to show b/c doesn't work when overflow-y property of drawer is set (for scrolling).
    On mobile, overflow-y is only set when drawer is open and you don't need the knob */}
      <NonMobileBox>
        <DrawerControl
          hasNoFilters={hasNoFilters}
          isOpen={isOpen}
          intro={intro}
          ui={ui}
        >
          <DrawerLabel dir={dir} onClick={() => handleDrawer(!isOpen)} ui={ui}>
            {lang[ui]['Filter Map']}
          </DrawerLabel>

          <DrawerKnob onClick={() => handleDrawer(!isOpen)}>
            <Arrows color="white" width=".8rem" height=".8rem" flip={isOpen} />
          </DrawerKnob>
        </DrawerControl>
      </NonMobileBox>
      <Drawer isOpen={isOpen} intro={intro} className={'scrollbar'}>
        <DrawerClickArea onClick={() => handleDrawer(!isOpen)} />
        {/* hasNoFilter prop and passing isOpen prop here is only for mobile */}
        <MobileBox>
          <DrawerControl hasNoFilters={hasNoFilters} ui={ui}>
            <DrawerLabel
              hasNoFilters={hasNoFilters}
              isOpen={isOpen}
              dir={dir}
              onClick={() => handleDrawer(!isOpen)}
              ui={ui}
            >
              {lang[ui]['Filter Map']}
              <MobileFilterIndicatorBox
                hasNoFilters={hasNoFilters}
                isOpen={isOpen}
              >
                <MobileFilterIndicator width={'auto'} px={2}>
                  {lang[ui]['FiltersApplied']}
                </MobileFilterIndicator>
              </MobileFilterIndicatorBox>
            </DrawerLabel>

            <DrawerKnob onClick={() => handleDrawer(!isOpen)}>
              <Arrows
                color="white"
                width=".8rem"
                height=".8rem"
                flip={isOpen}
              />
            </DrawerKnob>
          </DrawerControl>
        </MobileBox>
        <MobileBox>
          <PillBox dir={dir}>
            {allFields.map((field) => {
              const faValue = ui === 'fa' ? getFaValue(field) : null
              return selections[field] !== 'ALL' ? (
                <Pill key={field} ui={ui}>
                  {`${lang[ui][field]}: ${
                    ui === 'en' ? selections[field] : faValue
                  }`}
                  <CloseX key={field + 'x'} ui={ui}>
                    <FiX
                      color={Theme.colors.black}
                      size="18"
                      onClick={() => closePill(field)}
                    />
                  </CloseX>
                </Pill>
              ) : null
            })}
          </PillBox>
          {!hasNoFilters && <Border my={5} hasNoFilters={hasNoFilters} />}
        </MobileBox>
        <MobileBox pt={2} pb={5}>
          <YearSelector
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />
        </MobileBox>

        <SectionHead dir={dir}>{lang[ui]['Personal Data']}</SectionHead>
        {fields.map((fieldname) => (
          <Filter
            key={fieldname}
            handleChange={handleChange}
            selections={selections}
            fieldname={lang['en'][fieldname]}
            fieldnameFa={lang['fa'][fieldname]}
            options={
              vocabLookup[fieldname]['en'] ? vocabLookup[fieldname]['en'] : null
            }
            displayOptions={ui === 'fa' ? vocabLookup[fieldname]['fa'] : null}
            dir={dir}
            ui={ui}
          />
        ))}
        <Border my={5} />
        <SectionHead dir={dir}>{lang[ui]['Crime Data']}</SectionHead>
        <StyledP dir={dir}>{lang[ui]['Exclude']}</StyledP>

        {incidentFields.map((fieldname) => (
          <Filter
            key={fieldname}
            handleChange={handleChange}
            selections={selections}
            fieldname={lang['en'][fieldname]}
            fieldnameFa={lang['fa'][fieldname]}
            options={
              vocabLookup[fieldname]['en'] ? vocabLookup[fieldname]['en'] : null
            }
            displayOptions={ui === 'fa' ? vocabLookup[fieldname]['fa'] : null}
            dir={dir}
            ui={ui}
          />
        ))}
        <Border my={5} />
        <SectionHead dir={dir}>{lang[ui]['Legal']}</SectionHead>
        {legalFields.map((fieldname) => (
          <Filter
            key={fieldname}
            handleChange={handleChange}
            selections={selections}
            fieldname={lang['en'][fieldname]}
            fieldnameFa={lang['fa'][fieldname]}
            options={
              vocabLookup[fieldname]['en'] ? vocabLookup[fieldname]['en'] : null
            }
            displayOptions={ui === 'fa' ? vocabLookup[fieldname]['fa'] : null}
            dir={dir}
            ui={ui}
          />
        ))}
        {/* spacer so that you can see all field on scroll*/}
        <Box mt={'5rem'} />
        <MobileApply isOpen={isOpen} onClick={() => handleDrawer(!isOpen)}>
          <MobileApplyButton
            width={'auto'}
            height={'1.5rem'}
            p="0 .5rem"
            dir={dir}
          >
            {lang[ui]['Apply']}
            <Box pl={ui === 'en' ? 1 : 0} pr={ui === 'en' ? 0 : 1} pt={'2px'}>
              <Arrows
                color={Theme.colors.black}
                width=".8rem"
                height=".8rem"
                flip={ui === 'fa'}
              />
            </Box>
          </MobileApplyButton>
        </MobileApply>
      </Drawer>

      <NonMobileBox>
        <PillBox isOpen={isOpen} dir={dir}>
          {allFields.map((field) => {
            const faValue = ui === 'fa' ? getFaValue(field) : null
            return selections[field] !== 'ALL' ? (
              <Pill key={field} ui={ui}>
                {`${lang[ui][field]}:   ${
                  ui === 'en' ? selections[field] : faValue
                }`}
                <CloseX key={field + 'x'} ui={ui}>
                  <FiX
                    color={Theme.colors.black}
                    size="18"
                    onClick={() => closePill(field)}
                  />
                </CloseX>
              </Pill>
            ) : null
          })}
        </PillBox>
      </NonMobileBox>
    </>
  )
}

export default FilterDrawer

FilterDrawer.propTypes = {
  handleDrawer: PropTypes.func,
  selectedYear: PropTypes.array,
  setSelectedYear: PropTypes.func,
  isOpen: PropTypes.bool,
  reliVocab: PropTypes.object,
  reliVocabFa: PropTypes.object,
  genderVocab: PropTypes.object,
  genderVocabFa: PropTypes.object,
  occuVocab: PropTypes.object,
  occuVocabFa: PropTypes.object,
  eduVocab: PropTypes.object,
  eduVocabFa: PropTypes.object
}
